import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Footer from './Footer';
import './PurchaseConfirmation.css';

const PurchaseConfirmation = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Trigger Facebook Pixel Purchase event
        if (window.fbq) {
            window.fbq('track', 'Purchase', {currency: "USD", value: 19.00});
        }
    }, []);

    return (
        <>
            <Helmet>
                {/* Event snippet for Website sale conversion page */}
                <script>
                    {`
                        console.log("PurchaseConfirmation");
                        gtag('event', 'purchase', {
                            // <event_parameters>
                        });
                    `}
                </script>
            </Helmet>
            <Navbar />
            <div className="purchase-confirmation">
                <div className="confirmation-content">
                    <h1>Welcome to Premium! 🎉</h1>
                    <p>Congratulations! You now have access to all premium features.</p>
                    <p>Get ready to take your content to the next level!</p>
                    <p className="redirect-text">Your account may take a few minutes to update with premium features, so feel free to refresh the page if you don't see any changes.</p>
                    <button 
                        className="button-plain"
                        onClick={() => navigate('/app')}
                    >
                        Start Using Premium Features Now
                    </button>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PurchaseConfirmation; 